import { memo } from "react";
import * as images from "@/components/images/Images";
import { cn } from "@/lib/utils";
import Link from "next/link";
import Image, { StaticImageData } from "next/image";
import { Button } from "@/components/ui/button";
import { ROUTES } from "@/constants";

export type NavigationCardProps = {
  imageUrl?: string | StaticImageData;
} & React.ComponentProps<"div">;

const NavigationCard = ({
  className,
  imageUrl = images.menubg2,
}: NavigationCardProps) => {
  return (
    <div
      className={cn(
        "inline-flex flex-col bg-white rounded-3xl overflow-hidden w-full max-w-[280]",
        className
      )}
    >
      <Image
        src={imageUrl}
        alt="Languex logo"
        width={291}
        height={170}
        className="rounded-t-3xl w-full"
      />
      <div className="grid grid-cols-1 p-[15.4] gap-[9.63] text-center lg:p-4">
        <p className="text-base leading-[130%] lg:font-medium">
          Got a project?
        </p>
        <Button
          asChild
          variant="primary"
          className="font-medium text-sm border border-transparent w-full"
        >
          <Link href={ROUTES.startOrder} className="w-full">
            Start Order
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default memo(NavigationCard);
